import {
  BASIC_TIER,
  REGULAR_TIER,
  UNLIMITED_TIER,
} from "@chesshotel/constants";

type TranslateFn = (
  key: string,
  values?: Record<string, string | number>
) => string;

function translateWithNr(t: TranslateFn, key: string, nr: number): string {
  const translated = t(key, { nr });
  if (translated === key) {
    return key.replace("%nr", String(nr));
  }
  return translated;
}

export function getTierName(tier: number): string {
  if (tier === BASIC_TIER) return "BASIC";
  if (tier === REGULAR_TIER) return "REGULAR";
  if (tier === UNLIMITED_TIER) return "UNLIMITED";
  return "PREMIUM";
}

export function getTierBenefits(t: TranslateFn, tier: number): string[] {
  if (tier === BASIC_TIER) {
    return [
      translateWithNr(t, "%nr league games per day", 10),
      translateWithNr(t, "%nr game reviews per day", 5),
      translateWithNr(t, "Last %nr months database of played games", 6),
    ];
  }

  if (tier === REGULAR_TIER) {
    return [
      translateWithNr(t, "%nr league games per day", 20),
      translateWithNr(t, "%nr game reviews per day", 10),
      translateWithNr(t, "Last %nr months database of played games", 12),
      t("Ad free"),
    ];
  }

  if (tier === UNLIMITED_TIER) {
    return [
      t("Unlimited league games"),
      t("Unlimited game analysis"),
      t("Database of all games ever played"),
      t("Ad free"),
    ];
  }

  return [];
}
